module.exports = __webpack_public_path__ + "static/media/Sandesh_Sahane.4e95fb26.jpg";